import makeList from './makeList.js'

let viewFloor = '基本観測棟1F'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '基本観測棟 風除室',
        file: './data/I44o.JPG',
        rotation: -321.10848217022317,
        link: [
          {
            file: './data/I44e.JPG',
            position: [ 410.6003606764619, 1181.3768330788446, 4836.340185401004 ],
          },
          {
            file: './data/I44j.JPG',
            position: [ -2775.1453312066124, 1446.9294159052145, 3893.0160307637666 ],
          },
          {
            file: './data/I44r.JPG',
            position: [ -3885.536946951425, 942.402847716737, -2987.693072318448 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 369.71046770601333, 458.79732739420945 ],
        },
      },
      { description: '基本観測棟 放球室',
        file: './data/I44r.JPG',
        rotation: -267.76037902227347,
        link: [
          {
            file: './data/04b_R0010675.JPG',
            position: [ -4785.777859381962, 1106.5884784280092, -897.3387053705478 ],
          },
          {
            file: './data/I44o.JPG',
            position: [ 4407.963233081316, 445.2390959639056, -2299.549918063283 ],
          },
          {
            file: './data/I44k_2.JPG',
            position: [ -4470.0612249538335, 527.9458225828733, 2156.143241754253 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 690.4231625835189, 461.02449888641434 ],
        },
      },
      { description: '基本観測棟 機械室',
        file: './data/I44e.JPG',
        rotation: 11.261233263265325,
        link: [
          {
            file: './data/I44o.JPG',
            position: [ -4090.4009962747423, 147.4796572412562, -2858.521039256128 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 269.4877505567929, 523.3853006681516 ],
        },
      },
      { description: '基本観測棟 生物・夏期研究室',
        file: './data/I44j.JPG',
        rotation: -253.9303877124063,
        link: [
          {
            file: './data/I44o.JPG',
            position: [ 3650.6447967468434, -127.50213046163937, -3403.657519674635 ],
          },
          {
            file: './data/I44l.JPG',
            position: [ 4912.104508844993, 78.07022745572202, 885.0737147997462 ],
          },
          {
            file: './data/I44k_2.JPG',
            position: [ -2442.938773228167, 1.861663724065211, -4359.119101110926 ],
          },
          {
            file: './data/I44d.JPG',
            position: [ 2592.2356867769195, 1175.716484309268, -4102.877738389374 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 503.34075723830733, 639.1982182628063 ],
        },
      },
      { description: '基本観測棟 生物・夏期研究室(2)',
        file: './data/I44k_2.JPG',
        rotation: -163.62289690224918,
        link: [
          {
            file: './data/I44j.JPG',
            position: [ 4462.776113733015, -180.61468263664855, 2224.05168950279631 ],
          },
          {
            file: './data/I44d.JPG',
            position: [ 4793.519114401303, 1055.6833497258815, -913.1017353044665 ],
          },
          {
            file: './data/I44r.JPG',
            position: [ -2790.9643063100443, 843.3533340968154, -4053.382504167193 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 623.6080178173719, 567.9287305122496 ],
        },
      },
      { description: '基本観測棟 倉庫',
        file: './data/I44l.JPG',
        rotation: -139.99104970529436,
        link: [
          {
            file: './data/I44j.JPG',
            position: [ -4949.157929483237, 553.0412762073091, -312.9891555945874 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 298.44097995545656, 657.0155902004456 ],
        },
      },
      { description: '基本観測棟 階段室',
        file: './data/I44d.JPG',
        rotation: -207.27059291113665,
        link: [
          {
            file: './data/I44j.JPG',
            position: [ -654.6256178719109, -374.71938736674315, 4936.819671972648 ],
          },
          {
            file: './data/I44k_2.JPG',
            position: [ -4980.605728369776, -179.35382506785376, 235.60473537778174 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 505.5679287305122, 543.4298440979957 ],
        },
      },
      { description: '基本観測棟 放球デッキ',
        file: './data/04b_R0010675.JPG',
        rotation: -43.42802877480352,
        link: [
          {
            file: './data/I44r.JPG',
            position: [ 4858.547676889843, 37.60272139650254, -1153.9935594165934 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 764.1025641025642, 492.3076923076924 ],
          syowaZoom: [ 915.3846153846155, 518.1282051282053 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
